(function(){
  var d=document,r=d.documentElement;
  try{
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    r.classList.add('rr-js');
    var bar=d.createElement('div');bar.id='rr-progress';d.body.appendChild(bar);
    function onScroll(){
      var h=r.scrollHeight-innerHeight,y=scrollY||r.scrollTop;
      bar.style.width=(h>0?Math.min(100,y/h*100):0)+'%';
      r.classList.toggle('rr-scrolled',y>10);
    }
    addEventListener('scroll',onScroll,{passive:true});onScroll();
    var els=d.querySelectorAll('main .shopify-section:not(:first-child), .footer');
    els.forEach(function(e){e.classList.add('rr-reveal');e.querySelectorAll('.grid').forEach(function(g){g.classList.add('rr-stagger')})});
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('rr-in')});return}
    var io=new IntersectionObserver(function(a){a.forEach(function(x){if(x.isIntersecting){x.target.classList.add('rr-in');io.unobserve(x.target)}})},{threshold:.08,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e)});
    setTimeout(function(){els.forEach(function(e){e.classList.add('rr-in')})},4000);
  }catch(e){r.classList.remove('rr-js')}
})();
